import { ProjectWithStatuses } from "@/utils/types";
import { ProjectStatus } from "@/components/ProjectConfiguration";
import { useStatusGroups } from "./useStatusGroups";
import { useStatusIcons } from "./useStatusIcons";
import { useStatusOperations } from "./useStatusOperations";
import { Issue } from "@/types/issues";
import React from "react";
import { StatusGroupType } from "../StatusesContent";

interface UseStatusManagementProps {
  projectData: ProjectWithStatuses;
  currentProjectIssues: Record<string, Issue>;
  customProjectStatuses: ProjectStatus[];
}

interface StatusManagementHook {
  projectStatusGroups: StatusGroupType[];
  getStatusIcon: (status: string, iconType?: any) => React.ReactElement | null;
  handleCreateStatus: (statusName: string, statusType: string) => Promise<void>;
  handleUpdateStatus: (statusId: string, newName: string) => Promise<void>;
  handleDeleteStatus: (statusId: string) => Promise<void>;
  handleReorderColumns: (
    newOrder: Array<{ key: string; isDefault: boolean }>,
  ) => Promise<void>;
}

export const useStatusManagement = ({
  projectData,
  currentProjectIssues,
  customProjectStatuses,
}: UseStatusManagementProps): StatusManagementHook => {
  const { projectStatusGroups } = useStatusGroups({
    currentProjectIssues,
    customProjectStatuses,
  });

  const { getStatusIcon } = useStatusIcons({
    customProjectStatuses,
  });

  const {
    handleCreateStatus,
    handleUpdateStatus,
    handleDeleteStatus,
    handleReorderColumns,
  } = useStatusOperations({
    projectData,
    customProjectStatuses,
    projectStatusGroups,
  });

  return {
    projectStatusGroups,
    getStatusIcon,
    handleCreateStatus,
    handleUpdateStatus,
    handleDeleteStatus,
    handleReorderColumns,
  };
};
